import { Field, Form } from 'react-final-form';
import { Button, Col, Container, Row } from 'reactstrap';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../context';
import FieldTitle from '../../../Forms/FieldTitle';
import PartnerOfferingField from './PartnerOfferingField';

const PartnerOfferingForm = (props) => {
    const dispatch = useDispatch();
    const {
        refresh,
        toggle,
        partnerId,
        offering = {},
        isNew = false,
        offeringsList,
    } = props;

    const OfferingsSubmissionObject = useRef(offeringsList);
    const isPartnerOfferingFormPristine = useRef(true);

    const updateOfferingsSubmissionObject = ({ id, value }) => {
        let oldOject = OfferingsSubmissionObject.current;
        const newObject = oldOject.map((bitOffering) => {
            if (bitOffering.id === id) {
                isPartnerOfferingFormPristine.current = false;
                return { ...bitOffering, isEnabled: value };
            }
            return {
                ...bitOffering,
                subOfferings: bitOffering.subOfferings.map((so) => {
                    if (so.id === id) {
                        isPartnerOfferingFormPristine.current = false;
                        return { ...so, isEnabled: value };
                    }
                    return so;
                }),
            };
        });
        OfferingsSubmissionObject.current = newObject;
    };

    const submit = async (values) => {
        const payload = {
            ...values,
            offeringsList: OfferingsSubmissionObject.current,
        };

        let partnerOfferingRequest;
        if (isNew === true) {
            partnerOfferingRequest = dispatch(
                actions.offerings.createOffering(partnerId, payload)
            );
        } else {
            partnerOfferingRequest = dispatch(
                actions.offerings.updateOffering(partnerId, payload)
            );
        }

        partnerOfferingRequest.then(() => {
            refresh().then(toggle);
        });
    };

    const formRender = ({
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
    }) => (
        <form onSubmit={handleSubmit}>
            <Container>
                <Row>
                    <Col>
                        <FieldTitle title="Offering Name" required />
                        <Field
                            className="w-100 rounded p-2 bored"
                            component="input"
                            name="name"
                            placeholder="Name"
                            required
                        />
                    </Col>
                </Row>
                {offeringsList.map((offering) => (
                    <PartnerOfferingField
                        key={offering.id}
                        title={offering.name}
                        value={offering.isEnabled}
                        subOfferings={offering.subOfferings}
                        id={offering.id}
                        disabled={false}
                        callBack={updateOfferingsSubmissionObject}
                    />
                ))}
                <Row>
                    <Col className="d-flex justify-content-between mt-4">
                        <Button size="sm" onClick={toggle} color="danger">
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            size="sm"
                            className="mx-2"
                            type="submit"
                            disabled={submitting}>
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Container>
        </form>
    );

    return (
        <Form
            onSubmit={submit}
            initialValues={{
                ...offering,
                partnerId: partnerId,
            }}
            render={formRender}></Form>
    );
};

export default PartnerOfferingForm;
